/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {ADN_TARGETING_TYPES} from '../targeting/targeting-constants';

export function resetDimensionsBasedOnAdUnitOption(model: any): void {
  if (model.adUnitOption === 'RANGE') {
    model.dimensions = null;
  } else {
    model.minWidth = null;
    model.minHeight = null;
    model.height = null;
    model.width = null;
  }
}

export interface AdUnitCommonsHost {
  timeZones?: any[];
  specifyTimeZone?: boolean;
  timeZoneChange?: () => void;
  targetingTypes?: any[];
}

export function createAdUnitCommons(
  ctrl: AdUnitCommonsHost,
  LocalNetworkProfile: any,
  param = 'model',
  modelHolder?: any
): {
  setTimezoneChange: () => void;
  setTargetingTypes: () => void;
  getBeforeSubmitTimeZoneValue: () => string | null;
} {
  const getModel = () => modelHolder || (ctrl as any)[param];

  return {
    setTimezoneChange(): void {
      ctrl.timeZoneChange = () => {
        const model = getModel();
        if (ctrl.specifyTimeZone) {
          model.timeZone = model.timeZone || LocalNetworkProfile.get('timeZone');
        } else {
          model.timeZone = null;
        }
      };
    },
    setTargetingTypes(): void {
      ctrl.targetingTypes = _.map(ADN_TARGETING_TYPES, (val) => val);
    },
    getBeforeSubmitTimeZoneValue(): string | null {
      return ctrl.specifyTimeZone ? getModel()?.timeZone : null;
    }
  };
}
